// Auto-generated from package.json — do not edit
export const APP_VERSION = "0.1.2";
